import type { RootState } from "../store"

export const profileSelector = (state: RootState) => state.userDetails.profile
